export default function FavoriteStar({
  isFavorite,
  toggleFavorite,
  color = "black",
  swipeCase = false,
  disabled = false,
}) {
  const stopSwipeEvent = (e) => {
    e.stopPropagation();
  };

  const containerStyle = {
    width: 35,
    height: 35,
    border: 0,
    padding: 0,
    background: "transparent",
    cursor: disabled ? "wait" : "pointer",
    position: "relative",
    zIndex: 999999,
    pointerEvents: "auto",
    isolation: "isolate",
    touchAction: "manipulation",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...(swipeCase
      ? {
          alignItems: "flex-end",
        }
      : {}),
  };

const badgeStyle = {
  position: "absolute",
  right: swipeCase ? -1 : -2,
  bottom: swipeCase ? -1 : -2,
  width: 14,
  height: 14,
  borderRadius: "50%",
  background: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
};

  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={isFavorite}
      title={isFavorite ? "Remove from watchlist" : "Add to watchlist"}
      onPointerDown={stopSwipeEvent}
      onMouseDown={stopSwipeEvent}
      onTouchStart={stopSwipeEvent}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) toggleFavorite();
      }}
      style={{ ...containerStyle, opacity: disabled ? 0.55 : 1 }}
    >
      <svg
        width="35"
        height="35"
        viewBox="0 0 300 300"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="41"
          y1="93.5"
          x2="259"
          y2="93.5"
          stroke={color}
          strokeWidth="17"
          strokeLinecap="round"
        />

        <line
          x1="41"
          y1="154.5"
          x2="259"
          y2="154.5"
          stroke={color}
          strokeWidth="17"
          strokeLinecap="round"
        />

        <line
          x1="41"
          y1="214.75"
          x2="174"
          y2="214.75"
          stroke={color}
          strokeWidth="17"
          strokeLinecap="round"
        />
      </svg>

      <span style={badgeStyle}>
        {!isFavorite ? (
          <svg
            width="8"
            height="8"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="8"
              y1="36"
              x2="64"
              y2="36"
              stroke={color}
              strokeWidth="10"
              strokeLinecap="round"
            />

            <line
              x1="36"
              y1="8"
              x2="36"
              y2="64"
              stroke={color}
              strokeWidth="10"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <svg
            width="9"
            height="8"
            viewBox="0 0 74 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 36 L29 57 L68 7"
              stroke={color}
              strokeWidth="10"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        )}
      </span>
    </button>
  );
}
